import {
  RhDrawer, RhGrid, RhIcon, RhListContainer, RhListItem,
} from '@rhythm-ui/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { navigations } from '../../navigation';
import { logOut } from '../../utils';
import logo from '../../assets/images/EcolabsLogo.png';

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useSelector((state) => state.authentication);

  return (
    <RhDrawer className="h-screen bg-[#303C48] w-16 md:w-64 overflow-hidden">
      <RhGrid container direction="column" className="h-full">
        <RhGrid
          item
          container
          className="py-8 h-24 invisible md:visible"
          justifyContent="justify-center"
          alignItems="items-center"
        >
          <img src={logo} className="max-w-[75%]" alt="logo" />
        </RhGrid>
        <RhGrid item xs>
          <RhListContainer className="px-2">
            {navigations
              .filter((el) => el.role === token.role)
              .map((el) => (
                <RhListItem
                  className={`${
                    location.pathname.includes(el.path.replace('/', ''))
                      ? 'bg-primary-color-500 sidebar-link hover:bg-primary-color-500   rounded-md' : ' hover:bg-transparent transparant-link'
                  }  hover: rounded-md    text-white my-2`}
                  onClick={() => navigate(el.path)}
                  key={el.path}
                >
                  <RhListItem.Icon variant="primary">
                    <RhIcon icon={el.icon} />
                  </RhListItem.Icon>
                  <RhListItem.Text primary={el.label} />
                </RhListItem>
              ))}
          </RhListContainer>
        </RhGrid>
        <RhGrid item>
          <RhListContainer className="text-white">
            <RhListItem className="my-12 py-4 hover: hover:bg-gray-700" onClick={logOut}>
              <RhListItem.Icon variant="primary">
                <RhIcon icon="akar-icons:sign-out" size="lg" />
              </RhListItem.Icon>
              <RhListItem.Text primary="Sign Out" />
            </RhListItem>
          </RhListContainer>
        </RhGrid>
      </RhGrid>
    </RhDrawer>
  );
}

export default Sidebar;
